import { render, staticRenderFns } from "./ProgramStatusTag.vue?vue&type=template&id=0c19072a&"
import script from "./ProgramStatusTag.vue?vue&type=script&lang=ts&"
export * from "./ProgramStatusTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports